import { render, staticRenderFns } from "./admitCardByColMain.vue?vue&type=template&id=b561ace2&scoped=true&"
import script from "./admitCardByColMain.vue?vue&type=script&lang=js&"
export * from "./admitCardByColMain.vue?vue&type=script&lang=js&"
import style0 from "./admitCardByColMain.vue?vue&type=style&index=0&id=b561ace2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b561ace2",
  null
  
)

export default component.exports